import PermissionList from './PermissionList';

export default PermissionList;
